import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { MoveMultipleToProjectDTO } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  data: MoveMultipleToProjectDTO;
}

export const useMultipleMoveToProjectQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data }: IParams) => {
      await Api.orders.postMultipleMoveToProject(data);
    },
    onSuccess: async () => {
      client.invalidateQueries(['getOrdersByProcess']);
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
    onError: () => {
      client.invalidateQueries(['getOrdersByProcess']);
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
  });
};
